export default __webpack_public_path__ + "static/media/fees.6431b030.svg";